export const ADD_QUERY_STRING = 'ADD_QUERY_STRING';
export const ADD_LOCATION_SEARCH = 'ADD_LOCATION_SEARCH'

export const addQueryString = (queryString) => {
    return {
        type: ADD_QUERY_STRING,
        payload: queryString
    }
}

export const addLocationSearch = (queryStrings) => {
    return {
        type: ADD_LOCATION_SEARCH,
        payload: queryStrings
    }
}